import React, { useEffect, useState } from "react";
import Layout from "../Common/Layout";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const CRDList = () => {
  const [search, setSearch] = useState("");

  const [crds, setCrds] = useState([]);
  const navigate = useNavigate();

  const token = sessionStorage.getItem("token");

  // =====================
  // FETCH CRD LIST
  // =====================
  const fetchCRDList = async () => {
    try {
      const res = await axios.get(
        "https://irc.zentelex.com/api/commodity-receipts/allcrd",
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      setCrds(res.data.data || res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchCRDList();
  }, []);

  const filteredCRDs = crds.filter((crd) => {
    const keyword = search.toLowerCase();

    return (
      crd.crdNo?.toLowerCase().includes(keyword) ||
      crd.clientName?.toLowerCase().includes(keyword) ||
      crd.commodityName?.toLowerCase().includes(keyword) ||
      crd.receiptDate?.toLowerCase().includes(keyword) ||
      crd.quantityMT?.toLowerCase().includes(keyword)
    );
  });

  // =====================
  // PRINT
  // =====================
  const handlePrint = (crd) => {
    const win = window.open("", "_blank");

    win.document.write(`
      <html>
      <head>
        <title>CRD Print</title>
        <style>
          body{font-family:Arial;padding:20px;}
          table{width:100%;border-collapse:collapse;}
          td,th{border:1px solid #000;padding:6px;}
          h2{text-align:center;}
        </style>
      </head>

      <body>
        <h2>Commodity Receipt Document</h2>

        <table>
          <tr><th>CRD No</th><td>${crd.crdNo}</td></tr>
          <tr><th>Date</th><td>${crd.receiptDate}</td></tr>
          <tr><th>Client</th><td>${crd.clientName}</td></tr>
          <tr><th>Commodity</th><td>${crd.commodityName}</td></tr>
          <tr><th>No Of Bags</th><td>${crd.noOfBags}</td></tr>
          <tr><th>Quantity MT</th><td>${crd.quantityMT}</td></tr>
        </table>
      </body>
      </html>
    `);

    win.document.close();
    win.print();
  };

  return (
    <Layout>
      <div className="container-fluid mt-4">
        <div className="row mb-3">
          <div className="col-md-4">
            <input
              type="text"
              className="form-control"
              placeholder="Search CRD No / Client / Commodity / Date..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
        </div>

        <h4 className="fw-semibold mb-4">Commodity Receipt List</h4>

        {/* ================= DESKTOP TABLE ================= */}
        <div className="table-responsive d-none d-md-block">
          <table className="table table-bordered table-hover align-middle">
            <thead className="table-dark">
              <tr>
                <th>#</th>
                <th>CRD No</th>
                <th>Date</th>
                <th>Client</th>
                <th>Commodity</th>
                <th>Bags</th>
                <th>Qty (MT)</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {filteredCRDs.length === 0 ? (
                <tr>
                  <td colSpan="8" className="text-center">
                    No records found
                  </td>
                </tr>
              ) : (
                filteredCRDs.map((crd, index) => (
                  <tr key={crd.id}>
                    <td>{index + 1}</td>
                    <td>{crd.crdNo}</td>
                    <td>{crd.receiptDate}</td>
                    <td>{crd.clientName}</td>
                    <td>{crd.commodityName}</td>
                    <td>{crd.noOfBags}</td>
                    <td>{crd.quantityMT}</td>

                    <td>
                      <button
                        className="btn btn-success btn-sm me-2"
                        onClick={() => handlePrint(crd)}
                      >
                        Print
                      </button>

                      <button
                        className="btn btn-primary btn-sm"
                        onClick={() => navigate(`/crd-print/${crd.crdNo}`)}
                      >
                        View
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* ================= MOBILE CARD VIEW ================= */}
        <div className="d-md-none">
          {filteredCRDs.length === 0 ? (
            <p>No records found</p>
          ) : (
            filteredCRDs.map((crd, index) => (
              <div key={crd.id} className="card shadow-sm mb-3">
                <div className="card-body">
                  <h6 className="fw-bold mb-2">
                    {index + 1}. {crd.crdNo}
                  </h6>

                  <p className="mb-1">
                    <strong>Date:</strong> {crd.receiptDate}
                  </p>

                  <p className="mb-1">
                    <strong>Client:</strong> {crd.clientName}
                  </p>

                  <p className="mb-1">
                    <strong>Commodity:</strong> {crd.commodityName}
                  </p>

                  <p className="mb-1">
                    <strong>Bags:</strong> {crd.noOfBags}
                  </p>

                  <p className="mb-3">
                    <strong>Qty:</strong> {crd.quantityMT} MT
                  </p>

                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-success btn-sm w-50"
                      onClick={() => handlePrint(crd)}
                    >
                      Print
                    </button>

                    <button
                      className="btn btn-primary btn-sm w-50"
                      onClick={() => navigate(`/crd-print/${crd.crdNo}`)}
                    >
                      View
                    </button>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </Layout>
  );
};

export default CRDList;
